<template>
  <svg
    height="15"
    viewBox="0 0 128 128"
    width="15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m18.26 0a4.07 4.07 0 0 0 -4.07 4.07v122.93a1 1 0 0 0 1 1h6.14a1 1 0 0 0 1-1v-122.93a4.08 4.08 0 0 0 -4.07-4.07zm94.9 8.73a55.3 55.3 0 0 0 -18.91-3.28s-.1 0-.15 0-.09 0-.14 0c-9.46 0-18.88 1.81-28.11 3.63-13.65 2.71-27.73 5.48-41.52 1.92v22.41a56.67 56.67 0 0 0 12.67 1.64v18.35a54.65 54.65 0 0 1 -12.64-1.69v22.4a57.27 57.27 0 0 0 13.51 1.65h.59c9.36 0 18.68-1.85 27.81-3.65 15.19-3 30.9-6.12 46.23-.44a1 1 0 0 0 1.34-.94v-61.06a1 1 0 0 0 -.68-.94zm-57.48 63.34a104.81 104.81 0 0 1 -16.68 1.68v-18.33a103.55 103.55 0 0 0 16.72-1.68zm0-40.71a104.91 104.91 0 0 1 -16.68 1.7v-18.38a105.7 105.7 0 0 0 16.68-1.68zm18.71 16.81c-2.86.51-5.75 1.07-8.55 1.63s-5.43 1.07-8.16 1.56v-18.36c2.86-.52 5.76-1.08 8.56-1.64s5.43-1.06 8.15-1.56zm18.71 18.35a104.32 104.32 0 0 0 -16.71 1.66v-18.34a103.33 103.33 0 0 1 16.71-1.7zm0-40.73a104.34 104.34 0 0 0 -16.71 1.67v-18.32a103.55 103.55 0 0 1 16.71-1.68zm18.71 23.21a55.19 55.19 0 0 0 -16.71-2.84v-18.35a52.66 52.66 0 0 1 16.71 2.93z"
    />
  </svg>
</template>

<script>
export default {
  name: "FinishIcon",
};
</script>
